import creditsListRedux from '../../list/redux/reducer';

//export redux objects
export default {
	creditsListRedux
};
